import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCustomerDetails, updateState } from 'actions/actions';
import { navigate } from 'gatsby';


const normalize = (val) => (val ?? '').trim().toLowerCase();
const isAllowedSource = (val) => val === 'c1' || val === 'intellect';


export default () => {
  const dispatch = useDispatch();
  //Capturing applicationId of authenticated user 
  const applicationId = useSelector((s) => s.reducer?.applicationId);

  useEffect(() => {
    //Prevent crashes during gatsby build for SSR
    if (typeof window === 'undefined') return;

    //Capturing parameters from landing url for the fair and fast webapp
    const search = window.location.search || '';
    const path = window.location.pathname || '/';
    const params = new URLSearchParams(search);

    const isMobileQuery = params.has('mobile'); // ?mobile
    const isMobilePath = /^\/mobile(\/|$)/i.test(path); // /mobile or /mobile/...
    const priorMobile = sessionStorage.getItem('isMobile') === 'true';
    const isMobile = isMobileQuery || isMobilePath || priorMobile;

    //Capture the online banking source (intellect -> default or null source is c1)
    const rawSource = normalize(params.get('source'));
    const priorSource = normalize(sessionStorage.getItem('source'));
    const source = isAllowedSource(rawSource) ? rawSource : (isAllowedSource(priorSource) ? priorSource : null);

    //Update Redux state with the query param information (isMobile and source)
    dispatch(updateState({ isMobile, source }));

    //Update session storage with the query param information (isMobile and source)
    try {
      sessionStorage.setItem('isMobile', String(isMobile));
      if (source) {
        sessionStorage.setItem('source', source);
      }
      //Optional else case - add or remove if you observe any issues with confusions between intellect and c1 sessions
      // else {
      //   sessionStorage.removeItem('source');
      // }
    }
    catch (err) {
      console.error('Session storage failed:', err);
    }

    //If user is already authenticated, do nothing
    if (applicationId) {
      return;
    }

    //Get current location/path name
    const pathname = (typeof window !== 'undefined'
      ? window.location.pathname.replace(/\/+$/, '')
      : '/');


    //Start session authentication flow
    const sessionEndpoint = isMobile ? 'Session/Mobile/me' : 'Session/Desktop/me';
    const sessionUrl = `${process.env.GATSBY_BACKEND_URL}/${sessionEndpoint}`;
    //Attempt to retrieve session details. Upon success, navigate to the homepage of the fair and fast app(/loan-type). Upon failure, reauthenticate
    fetch(sessionUrl, { credentials: 'include' })
      .then((sessionResponse) => {
        if (sessionResponse.ok) {
          dispatch(
            getCustomerDetails(isMobile, () => {
              if (
                pathname === '' ||
                pathname === '/' ||
                pathname === '/unauthorized' ||
                pathname === '/callback'
              ) {
                navigate('/loan-type', { replace: true });
              }
            })
          );
        } else if (sessionResponse.status === 401) {
          const loginPath = isMobile ? 'Session/Mobile/Login' : 'Session/Desktop/Login';
          const returnUrl = encodeURIComponent(window.location.href);
          window.location.href = `${process.env.GATSBY_BACKEND_URL}/${loginPath}?returnUrl=${returnUrl}`;
        } else {
          console.error(`Unexpected session status: ${sessionResponse.status}`);
        }
      })
      .catch((err) => {
        console.error('Authentication failed:', err);
      });
  }, [dispatch, applicationId]);

  return <div></div>;
};